import React from 'react';
import './ToothConditionOverlay.css';

const facePoint = {
  mesial: [36, 50], distal: [66, 50], vestibular: [51, 48], lingual: [51, 55], palatina: [51, 55],
  raiz: [51, 112], incisal: [51, 24], dente: [51, 49], oclusal: [51, 30],
};

function MissingMark() {
  return <g className="condition-mark condition-mark--missing"><path d="M22 22 L78 72 M78 22 L22 72"/><circle cx="50" cy="47" r="34"/></g>;
}

function ExtractionMark({ done }) {
  return <g className={`condition-mark ${done ? 'condition-mark--extracted' : 'condition-mark--extraction'}`}><path d="M27 24 L74 70 M74 24 L27 70"/><path d="M21 47 H80"/></g>;
}

function LocalMark({ record, view }) {
  const [baseX, baseY] = facePoint[record.face] || facePoint.dente;
  const x = view === 'occlusal' ? (record.face === 'mesial' ? 28 : record.face === 'distal' ? 72 : 50) : baseX;
  const y = view === 'occlusal' ? (record.face === 'vestibular' ? 18 : ['lingual','palatina'].includes(record.face) ? 50 : 34) : baseY;
  if (record.condicao === 'carie') return <g className="condition-mark condition-mark--carie"><path d={`M${x-9} ${y} Q${x-6} ${y-10} ${x+1} ${y-7} Q${x+10} ${y-5} ${x+8} ${y+4} Q${x+4} ${y+11} ${x-5} ${y+7}Z`}/><circle cx={x-2} cy={y-2} r="2.2"/></g>;
  if (record.condicao === 'restauracao') return <g className="condition-mark condition-mark--restoration"><path d={`M${x-10} ${y-6} Q${x} ${y-13} ${x+10} ${y-6} L${x+8} ${y+8} Q${x} ${y+13} ${x-9} ${y+7}Z`}/><path d={`M${x-6} ${y} H${x+6}`}/></g>;
  if (record.condicao === 'selante') return <path className="condition-mark condition-mark--sealant" d={view === 'occlusal' ? 'M24 34 C35 28 40 39 50 34 C61 28 66 40 77 34' : `M${x-12} ${y} Q${x} ${y+7} ${x+12} ${y}`}/>;
  if (record.condicao === 'fratura') return <path className="condition-mark condition-mark--fracture" d={view === 'occlusal' ? 'M42 10 L49 25 L43 35 L55 48 L49 62' : `M${x-4} ${y-24} L${x+3} ${y-10} L${x-3} ${y} L${x+7} ${y+16}`}/>;
  if (record.condicao === 'outro') return <g className="condition-mark condition-mark--other"><circle cx={x} cy={y} r="9"/><text x={x} y={y+4}>!</text></g>;
  return null;
}

export default function ToothConditionOverlay({ records = [], view, transform }) {
  if (!records.length) return null;
  const missing = records.find(record => record.condicao === 'ausente');
  const extractionDone = records.find(record => record.condicao === 'extracao_realizada');
  const extraction = records.find(record => record.condicao === 'extracao_indicada');
  const crown = records.find(record => record.condicao === 'coroa');
  const implant = records.find(record => record.condicao === 'implante');
  const canal = records.find(record => record.condicao === 'canal');
  const prosthesis = records.find(record => record.condicao === 'protese');
  const surfaceTransform = view === 'front' ? transform : undefined;
  const localRecords = records.filter(record => {
    if (view === 'occlusal') return ['oclusal', 'incisal', 'dente'].includes(record.face);
    return record.face !== 'oclusal';
  });
  if (missing) return <g transform={surfaceTransform}><MissingMark/></g>;
  if (extractionDone) return <g transform={surfaceTransform}><ExtractionMark done/></g>;

  return <g className="tooth-condition-layer" transform={surfaceTransform}>
    {extraction && <ExtractionMark/>}
    {crown && <path className="condition-mark condition-mark--crown" d={view === 'occlusal' ? 'M20 19 Q20 8 32 7 H69 Q82 8 82 20 V49 Q80 62 67 63 H31 Q18 61 18 48Z' : 'M25 25 Q50 7 76 26 L73 62 Q50 79 28 62Z'}/>} 
    {prosthesis && <path className="condition-mark condition-mark--prosthesis" d={view === 'occlusal' ? 'M23 20 Q50 3 77 20 L75 52 Q50 67 24 52Z' : 'M28 30 Q50 12 73 30 L70 62 Q50 77 31 62Z'}/>} 
    {implant && view === 'front' && <g className="condition-mark condition-mark--implant"><path d="M46 69 L46 143 Q50 154 55 143 L55 69Z"/><path d="M42 83 H59 M42 94 H59 M43 105 H58 M44 116 H57 M45 127 H56"/></g>}
    {canal && view === 'front' && <g className="condition-mark condition-mark--canal"><path d="M42 46 Q51 35 60 46 L57 65 Q51 72 45 65Z"/><path d="M51 64 C49 93 52 120 52 147"/></g>}
    {localRecords.filter(record => !['ausente','extracao_realizada','extracao_indicada','coroa','implante','canal','protese','higido'].includes(record.condicao)).map((record,index)=><LocalMark key={`${record.id || index}-${record.face}`} record={record} view={view}/>)}
  </g>;
}
